import { push } from '@lagunovsky/redux-react-router'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import FormAstronaut from '../../components/Forms/FormAstronaut/FormAstronaut'
import FormForgottenPassword from '../../components/Forms/FormForgottenPassword/FormForgottenPassword'
import Typography from '../../components/Typography/Typography'

import hocChangeForgottenPassword from './hocForgottenPassword'

import gtmForgotPasswordClicked from 'services/gtm/gtmForgotPasswordClicked'
import useForgotPasswordViewed from 'services/gtm/useForgotPasswordViewed'
import './ForgottenPassword.scss'

const ForgottenPassword = ({ isAuth, forgottenPassword }) => {
    const intl = useIntl()
    const dispatch = useDispatch()
    useForgotPasswordViewed()

    if (isAuth) dispatch(push('/user-profile'))

    return (
        <Container fluid className={'d-flex flex-column'}>
            <div className={'forgotten-password-page d-flex flex-column'}>
                <Typography variant={'h2'}>{intl.formatMessage({ id: 'forms.forgottenPassword.title' })}</Typography>

                <div className={'forgotten-password-page--content d-flex'}>
                    <FormAstronaut />
                    <FormForgottenPassword
                        handleSubmit={(args) => {
                            gtmForgotPasswordClicked()
                            forgottenPassword(args)
                        }}
                        handleCancel={() => dispatch(push('/login'))}
                        loading={false}
                    />
                </div>
            </div>
        </Container>
    )
}

export default hocChangeForgottenPassword(ForgottenPassword)
